export default eventName => {
  // Attributes.
  const attributes = document.querySelectorAll('[data-on' + eventName + ']');
  for (const element of attributes) {
    let values = element.getAttribute('data-on' + eventName);
    values = values.split(',');
    for (let value of values) {
      value = value.split('=');
      if (value.length > 1) {
        element.setAttribute(value.shift(), value.join('='));
      } else {
        element.setAttribute(value[0], true);
      }
    }
  }

  // Styles.
  const styles = document.querySelectorAll('link[href][type="text/' + eventName + '"]');
  for (const element of styles) {
    // Create new element.
    const newElement = document.createElement('link');
    // Transfer attributes.
    for (const oldAttribute of element.attributes) {
      if (oldAttribute.name !== 'type') {
        newElement.setAttribute(oldAttribute.name, oldAttribute.value);
      }
    }
    // Set updated type.
    newElement.setAttribute('type', 'text/css');
    // Add new element to same parent as old.
    element.parentElement.appendChild(newElement);
    // Remove old attribute.
    element.remove();
  }

  // Scripts.
  const scripts = document.querySelectorAll('script[src][type="text/' + eventName + '"]');
  for (const element of scripts) {
    // Create new element.
    const newElement = document.createElement('script');
    // Transfer attributes.
    for (const oldAttribute of element.attributes) {
      if (oldAttribute.name !== 'type') {
        newElement.setAttribute(oldAttribute.name, oldAttribute.value);
      }
    }
    // Set updated type.
    newElement.setAttribute('type', 'text/javascript');
    // Add new element to same parent as old.
    element.parentElement.appendChild(newElement);
    // Remove old attribute.
    element.remove();
  }
};